module.exports = __webpack_public_path__ + "img/spia.8df0df1a.jpg";